import { useCookies } from "@vueuse/integrations/useCookies";
import destr from "destr";

const SharedCookieDefaults = {
  path: getCookiePath(),
  watch: true,
  secure: isSecure(),
  sameSite: isSecure() ? "lax" : "strict",
  // domain: getCookieDomain(),
  decode: (val) => destr(decodeURIComponent(val)),
  encode: (val) =>
    encodeURIComponent(typeof val === "string" ? val : JSON.stringify(val)),
};

const cookies = useCookies();

export { cookies };

export function setCookie(name, value, _opts = {}) {
  const opts = { ...SharedCookieDefaults, ..._opts };
  cookies.set(name, value, opts);
}

export function removeCookie(name, _opts = {}) {
  const opts = { ...SharedCookieDefaults, ..._opts };
  cookies.remove(name, opts);
}

function isSecure() {
  return location.protocol === "https:";
}

function getCookiePath() {
  console.log("import.meta.env.MODE", import.meta.env.MODE);
  if (import.meta.env.MODE === "development") return "/";
  if (import.meta.env.MODE === "staging") return "/";
  return "/";
}
